import React, { useEffect, useRef, useState } from "react";
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CHeaderText,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "src/components/Tooltip";
import ReactPaginate from "react-js-pagination";
import StaffDetailsById from "./staffDetailById";

import { getAllEmplyeesData, updateEmplyeesDataById } from "src/api/allApis";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Vakilkaro from "src/assets/brand/vakilkaro";
import { useSelector } from "react-redux";
import { setUpdateFalse } from "src/redux/actions/staffAction";
import { useDispatch } from "react-redux";
import { CSVLink } from "react-csv";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
  MODULE_GROUPS,
} from "src/services/const";
import { errorAlert, successAlert } from "src/utils/Swal";

const UserOperations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { newUpdate } = useSelector((state) => state?.staffReducer);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showAccordion, setShowAccordion] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [showSelectAndSearch, setShowSelectAndSearch] = useState(true);
  const [staffData, setStaffData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [printState, setPrintState] = useState(false);

  const SchemaName = sessionStorage.getItem("schemaName");
  const role = sessionStorage.getItem("role");
  const componentPDF = useRef();

  useEffect(() => {
    getAllEmplyesData();
  }, []);
  useEffect(() => {
    if (newUpdate === true) {
      getAllEmplyesData();
      dispatch(setUpdateFalse());
    }
  }, [newUpdate]);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const download_btn = () => {
    setPrintState(true);
  };
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const getAllEmplyesData = () => {
    const payload = { schemaName: SchemaName };

    getAllEmplyeesData(payload).then((res) => {
      setStaffData(res?.data);
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = staffData?.slice(indexOfFirstRow, indexOfLastRow);

  const handleEditLoan = (staffDetails) => {
    navigate("/staff/edit?isEdit=1", { state: { staffDetails } });
  };

  const handleViedDetails = (company) => {
    setShowSelectAndSearch(false);
    setSelectedCompany(company);
    setShowAccordion(true);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };
  const [showLogin, setShowLogin] = useState(false);
  const [permissionsModal, setPermissionsModal] = useState(false);
  const [selecetedUser, setSelectedUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [permitted_routes, setPermitted_routes] = useState([]);
  const [visible, setVisible] = useState(false);

  const handleLogin = (data) => {
    setSelectedUser(data);
    setShowLogin(true);
  };
  const handleModal = (e) => {
    const staffId = e?.id;
    setSelectedStaffId(staffId);
    let parsedRoutes = [];
    try {
      if (typeof e?.permitted_routes === "string") {
        const cleaned = e.permitted_routes
          .replace(/^"(.*)"$/, "$1")
          .replace(/\\"/g, '"');
        parsedRoutes = JSON.parse(cleaned);
      } else if (Array.isArray(e?.permitted_routes)) {
        parsedRoutes = e.permitted_routes;
      } else {
        parsedRoutes = [];
      }
      const selectedModules = parsedRoutes?.map((r) =>
        r?.path?.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()
      );
      const validModules = selectedModules.filter((m) =>
        Object.keys(MODULE_MAP).includes(m)
      );
      setPermissions(validModules);
    } catch (error) {
      console.error("Invalid permitted_routes JSON:", error);
      // setPermitted_routes([]);
      setPermissions([]);
    }
    setSelectedUser(e);
    setPermissionsModal(true);
  };

  const handleLoginOptions = async () => {
    setShowLogin(false);
    let parsedRoutes = [];

    if (typeof selecetedUser?.permitted_routes === "string") {
      const cleaned = selecetedUser.permitted_routes
        .replace(/^"(.*)"$/, "$1")
        .replace(/\\"/g, '"');
      parsedRoutes = JSON.parse(cleaned);
    } else if (Array.isArray(selecetedUser?.permitted_routes)) {
      parsedRoutes = selecetedUser.permitted_routes;
    } else {
      parsedRoutes = [];
    }

    const newTab = window.open(`${window.location.origin}/dashboard`, "_blank");
    if (!newTab) {
      alert("Popup blocked! Please allow popups for this website.");
      return;
    }
    const interval = setInterval(() => {
      try {
        if (newTab.sessionStorage) {
          newTab.sessionStorage.setItem(
            "routes",
            JSON.stringify(parsedRoutes || [])
          );
          newTab.sessionStorage.setItem(
            "role",
            selecetedUser?.employeeRole || ""
          );
          newTab.sessionStorage.setItem(
            "employeeId",
            selecetedUser?.user?.employeeId || ""
          );
          newTab.sessionStorage.setItem(
            "branc",
            selecetedUser?.branch.id || ""
          );
          clearInterval(interval);
          newTab.location.reload();
        }
      } catch (err) {
        console.error(err);
      }
    }, 500);
  };

  const normalizeKey = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const formatLabel = (slug) =>
    slug.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  const MODULE_MAP = Object.entries(MODULE_GROUPS)
    .flatMap(([groupName, modules]) =>
      modules.map((module) => {
        const normalizedKey = normalizeKey(module);
        return {
          key: normalizedKey,
          name: formatLabel(module),
          path: `/${module.replace(/_/g, "-")}`,
        };
      })
    )
    .reduce((acc, { key, name, path }) => {
      acc[key] = { name, path };
      return acc;
    }, {});

  const handleToggleModule = (module) => {
    const normalized = normalizeKey(module);
    setPermissions((prev) =>
      prev.includes(normalized)
        ? prev.filter((m) => m !== normalized)
        : [...prev, normalized]
    );
  };
  const savePermissions = async () => {
    const schemaName = sessionStorage.getItem("schemaName");
    const permitted_routes = permissions
      .filter((module) => MODULE_MAP[module])
      .map((module) => MODULE_MAP[module]);
    const finalPayload = { permitted_routes };
    console.log("permitted_routes", permitted_routes, selectedStaffId);
    try {
      const res = await updateEmplyeesDataById({
        id: selectedStaffId,
        permitted_routes,
        schemaName,
      });
      if (res?.status) {
        // fetchStaff();
        successAlert("Success", "Permissions updated successfully.");
        setPermissionsModal(false);
        getAllEmplyesData();
      }
    } catch (err) {
      errorAlert("Error", "Failed to save permissions.");
    }
  };

  return (
    <CRow className="content">
      <CModal
        visible={permissionsModal}
        onClose={() => setPermissionsModal(false)}
      >
        <CModalHeader>
          <CModalTitle>Permissions for</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <strong>Select Allowed Modules:</strong>
          <CAccordion alwaysOpen>
            {Object.entries(MODULE_GROUPS).map(
              ([groupName, modules], index) => (
                <CAccordionItem key={groupName} itemKey={index}>
                  <CAccordionHeader>{groupName}</CAccordionHeader>
                  <CAccordionBody>
                    <div className="d-flex flex-wrap">
                      {modules.map((module) => (
                        <CFormCheck
                          key={module}
                          type="checkbox"
                          label={formatLabel(module)}
                          className="me-4 mb-2"
                          // checked={permissions.includes(module)}
                          checked={permissions.includes(normalizeKey(module))}
                          onChange={() => handleToggleModule(module)}
                        />
                      ))}
                    </div>
                  </CAccordionBody>
                </CAccordionItem>
              )
            )}
          </CAccordion>
        </CModalBody>
        <CModalFooter>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <CButton
              style={{ background: "#3c4b64" }}
              onClick={() => setPermissionsModal(false)}
            >
              Cancel
            </CButton>
            <CButton
              style={{ background: "#3c4b64" }}
              onClick={savePermissions}
            >
              Update
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
      <CModal visible={showLogin} onClose={() => setShowLogin(false)}>
        <CCardHeader
          style={{ fontSize: "24px", fontWeight: "500", padding: "20px" }}
        >
          <CHeaderText> Are you sure you want to login ?</CHeaderText>
        </CCardHeader>
        <CCardBody style={{ padding: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <CButton
              style={{ background: "#3c4b64" }}
              onClick={() => setShowLogin(false)}
            >
              Cancel
            </CButton>
            <CButton
              style={{ background: "#3c4b64" }}
              onClick={handleLoginOptions}
            >
              Login
            </CButton>
          </div>
        </CCardBody>
      </CModal>

      <CCol xs={12}>
        <CCard className="mb-4 custom-card">
          <CCardHeader className="custom-card-header">
            <h5>Manage Staff</h5>
          </CCardHeader>
          <CRow>
            <CCol xs={12}>
              <CCardBody>
                <CCard>
                  <div className="search_bar">
                    <div className="search-inner">
                      {showSelectAndSearch && (
                        <div className="select-wrapper mr-10">
                          <CFormSelect
                            onChange={handleRowsPerPageChange}
                            size="sm"
                            className="mb-3 custom-form-input"
                            style={{ cursor: "pointer" }}
                            aria-label="Small select example"
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                          </CFormSelect>
                        </div>
                      )}
                      <div
                        className="search-wrapper"
                        style={{ display: "flex" }}
                      >
                        {showSelectAndSearch && (
                          <>
                            <CFormInput
                              type="text"
                              size="sm"
                              placeholder="Search"
                              aria-label="sm input example"
                              style={{ margin: "0px 0px 16px 0px" }}
                              onChange={handleSearchChange}
                              value={searchInput}
                              className="custom-form-input"
                            />

                            <span className="search-icon">
                              <i className="fa fa-search"></i>
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    {showSelectAndSearch && (
                      <>
                        {role === "employee" ? (
                          ""
                        ) : (
                          <div className="btn_add mt-0 mb-14">
                            <CButton
                              className="add-btn mr-10 w-auto"
                              onClick={download_btn}
                            >
                              Download
                            </CButton>
                            <CSVLink
                              data={
                                currentRows === undefined ? " " : currentRows
                              }
                              filename={"staff-table.csv"}
                            >
                              <CButton className="add-btn w-auto m-0">
                                CSV
                              </CButton>
                            </CSVLink>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <CCardBody>
                    <div
                      className={`new-table-container ${showAccordion ? "hidden" : ""
                        }`}
                    >
                      <div
                        className="new-common-table-wrapper mb-2"
                        ref={printState ? componentPDF : null}
                        style={{ padding: printState ? "20px" : "0px" }}
                      >
                        {printState && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              background:
                                "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                              padding: "20px",
                            }}
                          >
                            <img
                              src={COMPANY_AddLogo}
                              alt="Logo"
                              width="50px"
                              height="50px"
                            />
                            <p style={{ color: "#FFF" }}>Staff List</p>
                            <div style={{ textAlign: "start" }}>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: "#FFF",
                                  fontSize: "20px",
                                }}
                              >
                                {COMPANY_NAME}
                              </p>
                              <p
                                style={{ color: "#FFF" }}
                              >{`(${COMPANY_Address})`}</p>
                            </div>
                          </div>
                        )}
                        <CTable
                          className="custom-tablee"
                          style={{ marginTop: "20px" }}
                          hover
                          responsive
                        >
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-1"
                              >
                                S. No.
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-2"
                              >
                                Staff Names
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-3"
                              >
                                Staff Email ID
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-3"
                              >
                                Staff Mobile Number
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                scope="col"
                                className="col-md-2"
                              >
                                Status
                              </CTableHeaderCell>
                              {!printState && (
                                <>
                                  <CTableHeaderCell
                                    scope="col"
                                    className="col-md-3"
                                  >
                                    Action
                                  </CTableHeaderCell>
                                  <CTableHeaderCell
                                    scope="col"
                                    className="col-md-3"
                                  >
                                    Operations
                                  </CTableHeaderCell>
                                </>
                              )}
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {staffData && staffData?.length > 0 ? (
                              currentRows
                                ?.filter(
                                  (item) => item?.phoneNumber
                                  // ?.toLowerCase()
                                  // ?.includes(searchInput?.toLowerCase())s
                                )
                                ?.map((company, index) => (
                                  <CTableRow key={index}>
                                    <CTableDataCell>
                                      {indexOfFirstRow + index + 1}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.firstName}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.email || "--"}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.phoneNumber || "--"}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.status || "--"}
                                    </CTableDataCell>
                                    {!printState && (
                                      <>
                                        <CTableDataCell
                                          className="col-md-3"
                                          style={{
                                            padding: "10px 0px 10px 0px",
                                          }}
                                        >
                                          <Tooltip text="View">
                                            <FontAwesomeIcon
                                              role="button"
                                              icon={faEye}
                                              size="1x"
                                              className="viewIcon"
                                              onClick={() =>
                                                handleViedDetails(company)
                                              }
                                            />
                                          </Tooltip>
                                          {role === "employee" ? (
                                            ""
                                          ) : role === "manager" ? (
                                            ""
                                          ) : (
                                            <Tooltip text="Update">
                                              <FontAwesomeIcon
                                                role="button"
                                                icon={faPenToSquare}
                                                size="1x"
                                                onClick={() =>
                                                  handleEditLoan(company)
                                                }
                                                className="px-3 updateIcon"
                                              />{" "}
                                            </Tooltip>
                                          )}
                                        </CTableDataCell>
                                        <CTableDataCell>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <CButton
                                              style={{
                                                background: "#3c4b64",
                                              }}
                                              onClick={() =>
                                                handleModal(company)
                                              }
                                            >
                                              Permissions
                                            </CButton>
                                            <CButton
                                              style={{
                                                background: "#3c4b64",
                                              }}
                                              onClick={() =>
                                                handleLogin(company)
                                              }
                                            >
                                              Login
                                            </CButton>
                                          </div>
                                        </CTableDataCell>
                                      </>
                                    )}
                                  </CTableRow>
                                ))
                            ) : (
                              <div className="loading_data">Loading...</div>
                            )}
                          </CTableBody>
                        </CTable>
                      </div>

                      <div className="pagin-div">
                        <div style={{ fontSize: "16px", fontWeight: "600" }}>
                          Showing {indexOfFirstRow + 1} to{" "}
                          {Math?.min(indexOfLastRow, staffData?.length)} of{" "}
                          {staffData?.length} entries
                        </div>
                        <div className="pagination-container">
                          <ReactPaginate
                            activePage={currentPage}
                            itemsCountPerPage={rowsPerPage}
                            totalItemsCount={staffData?.length}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            prevPageText="Previous"
                            nextPageText="Next"
                            firstPageText="First"
                            lastPageText="Last"
                            innerClass="pagination"
                            itemClass="page-item"
                            linkClass="page-link"
                          />
                        </div>
                      </div>
                    </div>
                    {showAccordion && (
                      <StaffDetailsById
                        selectedCompany={selectedCompany}
                        setShowAccordion={setShowAccordion}
                        setShowSelectAndSearch={setShowSelectAndSearch}
                      />
                    )}
                  </CCardBody>
                </CCard>
              </CCardBody>
            </CCol>
          </CRow>
        </CCard>
      </CCol>
      <CCol xs={12}>
        <div
          className={`accordion-container ${showAccordion ? "visible" : ""}`}
        ></div>
      </CCol>
    </CRow>
  );
};

export default UserOperations;
